// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y0xuK","colBig":"styles_colBig__15jtd","colSmall":"styles_colSmall__34MzR"};